import RefreshIcon from "@atlaskit/icon/core/refresh";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";

export function RestoreDataDropdownItem({onSelect}: {onSelect: () => void}) {
    return (
        <AnankeDropdownItem
            onClick={onSelect}
            elemBefore={<RefreshIcon label="" />}
        >
            Restore
        </AnankeDropdownItem>
    );
}
